import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import SessionPicture from './SessionPicture'
import SessionService from './SessionService'
import SessionCase from './SessionCase'
import style from './style.module.less'
import Right from './Right'

@inject('stepTwoStore')
@observer
export default class extends Component {
  render() {
    const { anchor } = this.props.stepTwoStore
    const activeKey = anchor.find(item => item.active).key
    return (
      <div
        className={style.provider}
        id="detailEditorWrapper"
        style={{ minHeight: activeKey === 3 ? 680 : 270 }}
      >
        {activeKey === 1 && <SessionPicture />}
        {activeKey === 2 && <SessionService />}
        {activeKey === 3 && <SessionCase />}
        <Right />
      </div>
    )
  }
}
